import styled, { css } from 'styled-components'

import { updatedMedia } from 'client/styles'
import Date from './BookingDate'

export const DatesContainer = styled.div`
  display: flex;
  align-items: center;
`

export const DateWrapper = styled.div`
  cursor: pointer;
  position: relative;
  color: ${({ theme }) => theme.colors.grey3};
  font-weight: 500;
  font-size: 14px;
  font-family: var(--font-grotesk);
`

export const CheckinDate = styled(Date)``

export const CheckoutDate = styled(Date)``

export const ButtonClose = styled.div`
  align-self: flex-end;
`

export const Spacer = styled.div`
  display: none;
`

export const SpacerMobile = styled.span`
  display: block;
  margin-inline: 4px;
  margin-block: 0;
  ${updatedMedia.desktop} {
    display: none;
  }
`

export const Ready = styled.div`
  background-color: ${({ theme }) => theme.colors.grey8};
  inset-block-end: 0;
  box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.15);
  inset-inline-start: 0;
  padding-block: 0.75em;
  padding-inline: 0.75em;
  position: absolute;
  width: 100%;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.families.primary};
  ${updatedMedia.desktop} {
    display: none;
  }
`

export const DatePickerBase = styled.div<{ operationMode: string; openCalendar: boolean }>`
  &.readonly {
    ${DateWrapper} {
      white-space: nowrap;
      div {
        display: none;
      }
      svg {
        display: none;
      }
    }
    ${CheckinDate} {
      display: flex;
      &:after {
        display: block;
        content: '-';
        width: 10px;
        text-align: center;
      }
    }
    ${CheckoutDate} {
      display: flex;
      &:after {
        display: block;
        content: '·';
        width: 10px;
        text-align: center;
      }
    }
  }

  &.borderless {
    position: relative;
    ${ButtonClose} {
      display: none;
    }
    ${DateWrapper} {
      padding-block: 0;
      padding-inline: 12px;
      color: ${({ theme }) => theme.colors.grey2};
      font-weight: 700;
      font-size: 16px;
      white-space: nowrap;
      display: flex;
      align-items: center;
      div {
        display: none;
      }
      svg {
        margin-inline-end: 6px;
        fill: ${({ theme }) => theme.colors.grey3};
      }
    }
    ${CheckinDate}, ${CheckoutDate} {
      padding-block: 8px;
      padding-inline: 8px;
      min-width: 110px;
      border-radius: 50px;
      border: 2px solid ${({ theme }) => theme.colors.grey8};
      &:hover {
        background: var(--color--neutral--300);
      }
    }
    ${CheckinDate} {
      ${updatedMedia.desktop} {
        padding-block: 10px;
        padding-inline: 10px;
      }
    }
    ${CheckoutDate} {
      svg {
        display: none;
      }

      ${updatedMedia.desktop} {
        padding-block: 10px;
        padding-inline: 10px;

        svg {
          display: block;
        }
      }
    }

    ${Spacer} {
      display: block;
      height: 26px;
      width: 2px;
      background-color: ${({ theme }) => theme.colors.grey5};
      margin-inline: 4px;
      margin-block: 0;

      &.spacer-middle {
        display: none;

        ${updatedMedia.desktop} {
          display: block;
        }
      }
    }
  }

  &.full {
    border: none;
    padding-block: 12px;
    padding-inline: 12px;
    border-block-end: 2px solid var(--color--neutral--400);
    max-height: stretch;

    ${DateWrapper} {
      color: ${({ theme }) => theme.colors.grey2};
      div {
        margin-block-end: 6px;
      }
      span {
        display: block;
        font-weight: 700;
        font-size: 16px;
      }
    }
    ${CheckinDate} {
      padding-block: 12px;
      padding-inline: 12px 0;
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: max-content;
    }

    ${CheckoutDate} {
      padding-block: 12px;
      padding-inline: 0;
      width: 100%;

      svg {
        display: none;
      }
    }

    ${({ openCalendar }) =>
      openCalendar &&
      css`
        background-color: ${({ theme }) => theme.colors.grey8};
        padding-block: 0;
        padding-inline: 0;
        position: fixed;
        inset-inline-start: 0;
        inset-inline-end: 0;
        inset-block-start: 0;
        inset-block-end: 0;
        border: none;
        z-index: 2;

        ${DatesContainer} {
          display: flex;
          justify-content: flex-end;
          padding-block: 20px;
          padding-inline: 20px;
        }

        ${CheckinDate}, ${CheckoutDate} {
          display: none;
        }

        ${SpacerMobile} {
          display: none;
        }
      `}

    ${({ openCalendar }) =>
      !openCalendar &&
      css`
        ${DatesContainer} {
          &:hover {
            background: var(--color--neutral--300);
            border-radius: 50px;
          }
        }
      `}
  }
`
